import Vue from 'vue'
import Particles from 'particles.vue'

Vue.use(Particles)
